import { $sxhr } from "../../services/http";

export default {
  dicParamsGetTree: info => {
    return $sxhr.post("dic/params/getTree", info);
  },
  upload: info => {
    return $sxhr.upload(info);
  },
  getAnonymousId: info => {
    return $sxhr.post("anonymous/getId", info);
  },
  serchBusiness: info => {
    return $sxhr.post("api/business/search", info);
  },
  getPromoterInfo: info => {
    return window.$sk.$skxhr("api/promoter/card/get", info);
  },
  getCtaList: info => {
    return window.$sk.$skxhr("api/tenant/setting/cta/query", info);
  },
  getCustomFrom: info => {
    return window.$sk.$skxhr("api/customform/get", info);
  },
  getJsSdk:info => {
    const path = "api/wework/jssdk/get";
    return window.$sk.$skxhr(path, info);
  }
};
